export default __webpack_public_path__ + "static/media/coupon-img.a2bd44e5.jpeg";